<template>
  <RadioButtonInput
    v-if="currentS3User && canSwitchLanguage"
    id="guest-language-toggle"
    :aria-label="t('homeowner_experience.language_toggle')"
    :options="languageOptions"
    :modelValue="currentS3User.preferred_language"
    :disabled="saving"
    @update:modelValue="setLanguage"
  />
</template>
<script setup lang="ts">
import RadioButtonInput from '@component-module/components/RadioButtonInput/RadioButtonInput.vue';
import { useCanSwitchLanguage } from '@shared/composables/useCanSwitchLanguage';
import { PreferredLanguageType, UserRoutesRepository } from '@shared/generated';
import { useJobStore } from '@shared/stores/job';
import { useUserStore } from '@shared/stores/user';
import { storeToRefs } from 'pinia';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const userStore = useUserStore();
const { currentS3User } = storeToRefs(userStore);
const { jobContractorDetails } = storeToRefs(useJobStore());
const saving = ref(false);
const canSwitchLanguage = useCanSwitchLanguage(
  () => jobContractorDetails.value.id
);
const languageOptions = computed(() =>
  [PreferredLanguageType.ENGLISH, PreferredLanguageType.SPANISH].map(
    (language) => ({
      value: language,
      label: t(`common_user.preferred_language.${language}`)
    })
  )
);

const setLanguage = async (language: PreferredLanguageType) => {
  if (currentS3User.value?.preferred_language === language) return;
  try {
    saving.value = true;
    const updatedUser =
      await UserRoutesRepository.userRoutesUpdateMePreferredLanguage({
        requestBody: { preferred_language: language }
      });
    userStore.setCurrentS3User(updatedUser);
  } finally {
    saving.value = false;
  }
};
</script>
